<template>
  <div class="coupon-section" v-if="couponList.length > 0">
    <div class="config-nav-name" data-type="coupon" :data-id="id" style="display:none">{{ title || "优惠券" }}</div>
    <!-- 头部区域 -->
    <div class="section-header">
      <div class="header-content">
        <div class="title-area">
          <div class="icon-wrapper">
            <img class="coupon-icon" :src="couponicon" alt="优惠券图标" />
          </div>
          <div class="title-text">
            <h2 class="main-title">年度促销</h2>
            <p class="sub-title">好卷天天领</p>
          </div>
        </div>

        <div class="header-action" v-show="total > 4">
          <button class="view-more-btn" @click="toCouponCenter">
            <span>领取更多</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6 12L10 8L6 4"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- 优惠券列表 -->
    <div class="coupon-list-container">
      <div class="coupon-grid">
        <template v-for="item in couponList">
          <coupon-item :key="item.id" :item="item" @hadPick="getCoupon" class="coupon-item-wrapper"></coupon-item>
        </template>
      </div>

      <!-- 空状态 -->
      <div class="empty-state" v-if="couponList.length === 0">
        <div class="empty-icon">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M42.6667 25.3333H21.3333M42.6667 34.6667H21.3333M16 12H48C51.3137 12 54 14.6863 54 18V46C54 49.3137 51.3137 52 48 52H16C12.6863 52 10 49.3137 10 46V18C10 14.6863 12.6863 12 16 12Z"
              stroke="#FF9D6C"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M24 44H40" stroke="#FF9D6C" stroke-width="2.5" stroke-linecap="round" />
          </svg>
        </div>
        <p class="empty-text">暂无可用优惠券</p>
      </div>
    </div>
  </div>
</template>

<script>
import couponicon from "@/assets/img/coupon/couponicon.png";
import { getStoreValidCouponList } from "@/api/coupon/index.js";
import CouponItem from "./components/Coupon.vue";

export default {
  name: "CouponList",
  components: {
    CouponItem
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      couponicon,
      couponList: [],
      total: 0
    };
  },
  methods: {
    toCouponCenter() {
      this.$router.push({
        path: "/new-products/coupon-center"
      });
    },
    // 获取优惠券
    async getCoupon() {
      try {
        const res = await getStoreValidCouponList({ page: 1, pageSize: 4 });
        this.couponList = res.rows;
        this.total = res.totalSize;
      } catch (error) {
        console.error("获取优惠券失败:", error);
        this.$message.error("获取优惠券失败，请稍后重试");
      }
      this.$nextTick(() => {
        this.$bus.$emit("resetLeftNav");
      });
    }
  },
  created() {
    this.getCoupon();
  }
};
</script>

<style lang="scss" scoped>
.coupon-section {
  width: 100%;
  background: linear-gradient(180deg, #ffffff 0%, #fff3ef 100%);
  border-radius: 2px;
  // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  padding: 24px;
  margin-bottom: 24px;
  transition: all 0.3s ease;

  &:hover {
    // box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
  }
}

.section-header {
  margin-bottom: 20px;

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-area {
      display: flex;
      align-items: center;
      gap: 16px;

      .icon-wrapper {
        width: 56px;
        height: 56px;
        background: linear-gradient(135deg, #fe7448, #ff9d6c);
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 12px rgba(254, 116, 72, 0.25);

        .coupon-icon {
          width: 32px;
          height: 32px;
          filter: brightness(0) invert(1);
        }
      }

      .title-text {
        .main-title {
          font-size: 28px;
          font-weight: 700;
          color: #fe7448;
          margin: 0 0 4px 0;
          line-height: 1.2;
        }

        .sub-title {
          font-size: 16px;
          color: #666;
          margin: 0;
          font-weight: 500;
        }
      }
    }

    .header-action {
      .view-more-btn {
        display: flex;
        align-items: center;
        gap: 8px;
        background: rgba(254, 116, 72, 0.1);
        border: 1px solid rgba(254, 116, 72, 0.3);
        border-radius: 20px;
        padding: 10px 20px;
        font-size: 14px;
        font-weight: 600;
        color: #fe7448;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          background: rgba(254, 116, 72, 0.15);
          transform: translateX(4px);
          box-shadow: 0 4px 12px rgba(254, 116, 72, 0.2);

          svg {
            transform: translateX(2px);
          }
        }

        svg {
          transition: transform 0.3s ease;
        }
      }
    }
  }
}

.coupon-list-container {
  .coupon-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 4px;

    .coupon-item-wrapper {
      transition: transform 0.3s ease;

      &:hover {
        transform: translateY(-4px);
      }
    }
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;

    .empty-icon {
      margin-bottom: 16px;
      opacity: 0.7;
    }

    .empty-text {
      font-size: 16px;
      color: #999;
      margin: 0;
    }
  }
}

// 响应式设计
@media (max-width: 1024px) {
  .coupon-section {
    padding: 20px;

    .section-header .header-content .title-area {
      .icon-wrapper {
        width: 48px;
        height: 48px;

        .coupon-icon {
          width: 28px;
          height: 28px;
        }
      }

      .title-text {
        .main-title {
          font-size: 24px;
        }

        .sub-title {
          font-size: 14px;
        }
      }
    }
  }

  .coupon-list-container .coupon-grid {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .coupon-section {
    padding: 16px;
    border-radius: 12px;

    .section-header .header-content {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;

      .title-area {
        gap: 12px;

        .icon-wrapper {
          width: 44px;
          height: 44px;
          border-radius: 10px;

          .coupon-icon {
            width: 24px;
            height: 24px;
          }
        }

        .title-text {
          .main-title {
            font-size: 22px;
          }
        }
      }

      .header-action {
        align-self: stretch;

        .view-more-btn {
          width: 100%;
          justify-content: center;
        }
      }
    }
  }

  .coupon-list-container .coupon-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 480px) {
  .coupon-section {
    padding: 12px;

    .section-header .header-content .title-area {
      .title-text {
        .main-title {
          font-size: 20px;
        }

        .sub-title {
          font-size: 13px;
        }
      }
    }
  }
}
</style>
